document.addEventListener("DOMContentLoaded",function onDdocLoaded(){
    document.removeEventListener("DOMContentLoaded", onDdocLoaded)
    const ctnr = document.getElementById("focus-section")
    if (!ctnr) return
    new HScrollAnimation(ctnr)
})

class HScrollAnimation {
    private animatedEles: Array<IAnimatedItem> = []
    private distParams!: IDistancePrarms
    private pstg: number = -1
    private rafHandle:number | undefined

    constructor(private ctnr: HTMLElement){
        this.initAnimatedEles()
        this.initEventListener()
        this.calcTopDistanceParams()
        this.checkAndAnimate()
    }

    private initAnimatedEles(){
        this.animatedEles = []
        this.ctnr.querySelectorAll("[data-a-s][data-a-e]").forEach((node:Element) => {
            const ele = node as HTMLElement
            const {aS, aE} = ele.dataset  as {aS:string, aE: string}
            const start = parseFloat(aS)
            const totalDistance = parseFloat(aE) - start
            this.animatedEles.push({ele, start, totalDistance})
        })
    }

    private initEventListener(){
       document.addEventListener("scroll", () =>{
            this.checkAndAnimate()
        }) 

        window.addEventListener("resize", () => {
            this.calcTopDistanceParams()
            this.checkAndAnimate()
        })
    }

    private checkAndAnimate(){
        const pstg = this.getAnimatePstg()
        if (pstg === this.pstg) return
        if (this.rafHandle) cancelAnimationFrame(this.rafHandle)
        this.rafHandle = requestAnimationFrame(()=>{
            this.pstg = pstg
            this.doAnimate()
        })
    }

    private calcTopDistanceParams() {
        const ctnrRect = this.ctnr.getBoundingClientRect()
        const startPos = ctnrRect.top + document.documentElement.scrollTop - window.innerHeight
        const totalDist = ctnrRect.height + window.innerHeight
        this.distParams= {startPos, totalDist}
    }

    private getAnimatePstg(): number{
        const topDis = document.documentElement.scrollTop - this.distParams.startPos
        if (topDis < 0) return 0
        const pstg = topDis/this.distParams.totalDist
        if (pstg > 1) return 1
        return pstg
    }

    private doAnimate(){
        this.animatedEles.forEach(ele => {
            ele.ele.style.transform = `translate3d(${ele.start + this.pstg * ele.totalDistance}${window.innerWidth >= window.innerHeight ? "vw" : "vh"}, 0, 0)`
        })
    }

}

interface IDistancePrarms {
    startPos: number
    totalDist: number
}

interface IAnimatedItem {
    ele: HTMLElement
    start: number
    totalDistance: number
}